import React from 'react';
import { AlertCircle, TrendingDown, Users, Target } from 'lucide-react';
import { Button } from './ui/button';

const CostOfBadHires = ({ onConsultationClick }) => {
  const costs = [
    {
      icon: <TrendingDown className="h-6 w-6" />,
      title: "Strong CV. Weak Accountability.",
      description: "Experience on paper doesn't guarantee operational stability."
    },
    {
      icon: <AlertCircle className="h-6 w-6" />,
      title: "Impressive Interview. Poor Pressure Tolerance.",
      description: "Performance under stress reveals true operational capability."
    },
    {
      icon: <Users className="h-6 w-6" />,
      title: "Experience in Practice. Instability in Practice.",
      description: "Past roles don't predict future reliability or team impact."
    },
    {
      icon: <Target className="h-6 w-6" />,
      title: "Lost Training Investment.",
      description: "Every failed placement wastes months of operational development."
    }
  ];

  return (
    <section className="py-20 bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-normal text-black mb-6" style={{ fontFamily: "'DM Serif Display', serif", textShadow: 'none', WebkitFontSmoothing: 'antialiased' }}>
            The Cost of Bad Hires
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" style={{ fontFamily: "'DM Serif Display', serif" }}>
            Rehiring costs. Lost training investment. Team morale decline. Guest experience inconsistency. Manager burnout. Reputation damage.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-16">
          {costs.map((cost, index) => (
            <div 
              key={index}
              className="bg-white border border-gray-200 rounded-lg p-6 hover:border-[#FFD000] transition-all duration-300 group"
            >
              <div className="w-12 h-12 bg-[#FFD000]/10 rounded-lg flex items-center justify-center text-[#FFD000] mb-4 group-hover:bg-[#FFD000] group-hover:text-black transition-all duration-300">
                {cost.icon}
              </div>
              <h3 className="text-lg font-normal text-black mb-2">
                {cost.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {cost.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-[#FFD000]/10 to-[#C8E347]/10 border-l-4 border-[#FFD000] rounded-lg p-6 max-w-4xl mx-auto">
          <p className="text-sm font-semibold text-black text-center">
            If you have replaced the same role more than once in 12 months, the issue is not sourcing.{' '}
            <span className="text-[#FFD000]">It is screening.</span>
          </p>
        </div>

        <div className="text-center mt-8">
          <Button 
            onClick={onConsultationClick}
            className="bg-[#FFD000] hover:bg-[#FFD000]/90 text-black font-semibold px-6 py-4 text-sm transition-all duration-300 hover:scale-105"
          >
            Fix Your Hiring Process
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CostOfBadHires;
